module.exports = __webpack_public_path__ + "assets/bcda300e319e07e5d1542fe7f8989ed0.png";